"use strict";

var formA11y = require("./formA11y");

var pendingFocus = null;

/**
 * Hand focus to the first field in error once the current batch of `invalid` events has
 * finished writing its messages.
 *
 * This cannot live in `validateForm` alone. When native constraint validation fails on a
 * form that is not marked `novalidate`, the browser fires `invalid` on each control and
 * then returns *without* dispatching `submit` - so the submit handler never runs. Every
 * checkout form sets `novalidate`, but the account forms do not, which is why /login
 * showed its error message and never moved focus. `invalid` fires either way, so the
 * focus is scheduled from there.
 *
 * Deferred by a task so it runs once per submission rather than once per invalid field,
 * and only after every message has been rendered.
 *
 * @param {HTMLFormElement} [form] - form to search; the whole document when absent
 * @returns {void}
 */
function scheduleFocusFirstInvalid(form) {
    if (pendingFocus) {
        return;
    }
    pendingFocus = setTimeout(function () {
        pendingFocus = null;
        formA11y.focusFirstInvalid(form || undefined);
    }, 0);
}

/**
 * Validate whole form. Requires `this` to be set to form object
 * @param {jQuery.event} event - Event to be canceled if form is invalid.
 * @returns {boolean} - Flag to indicate if form is valid
 */
function validateForm(event) {
    var valid = true;
    if (this.checkValidity && !this.checkValidity()) {
        // safari
        valid = false;
        if (event) {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
        }
        $(this).find("input, select").each(function () {
            if (!this.validity.valid) {
                $(this).trigger("invalid", this.validity);
            }
        });
        // Every error message is now rendered and associated, so hand focus to the first
        // field in error: that is what makes a screen reader read the message out.
        formA11y.focusFirstInvalid(this);
    }
    return valid;
}

/**
 * Remove all validation. Should be called every time before revalidating form
 * @param {element} form - Form to be cleared
 * @returns {void}
 */
function clearForm(form) {
    $(form).find(".form-control.is-invalid").removeClass("is-invalid");
    formA11y.clearInvalid(form);
}

module.exports = {
    invalid: function () {
        $("form input, form select").on("invalid", function (e) {
            e.preventDefault();
            this.setCustomValidity("");
            if (!this.validity.valid) {
                var validationMessage = this.validationMessage;
                $(this).addClass("is-invalid");
                formA11y.markInvalid(this);
                if (this.validity.patternMismatch && $(this).data("pattern-mismatch")) {
                    validationMessage = $(this).data("pattern-mismatch");
                }
                if ((this.validity.rangeOverflow || this.validity.rangeUnderflow)
                    && $(this).data("range-error")) {
                    validationMessage = $(this).data("range-error");
                }
                if ((this.validity.tooLong || this.validity.tooShort)
                    && $(this).data("range-error")) {
                    validationMessage = $(this).data("range-error");
                }
                if (this.validity.valueMissing && $(this).data("missing-error")) {
                    validationMessage = $(this).data("missing-error");
                }
                $(this).parents(".form-group").find(".invalid-feedback")
                    .text(validationMessage);
                scheduleFocusFirstInvalid(this.form);
            }
        });
    },

    submit: function () {
        $("form").on("submit", function (e) {
            return validateForm.call(this, e);
        });
    },

    buttonClick: function () {
        $("form button[type=\"submit\"], form input[type=\"submit\"]").on("click", function () {
            // clear all errors when trying to submit the form
            clearForm($(this).parents("form"));
        });
    },

    functions: {
        validateForm: function (form, event) {
            // `validateForm` reads `this.checkValidity`, so it needs the raw form element:
            // passing a jQuery wrapper made this silently report every form as valid.
            var element = $(form)[0];
            return element ? validateForm.call(element, event || null) : true;
        },
        clearForm: clearForm
    }
};
